
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-modal",
      function () {
        return require("private-next-pages/joy-ui/react-modal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-modal"])
      });
    }
  